
























import Vue from 'vue'
import { Faq } from '@/types/common'
export default Vue.extend({
  props: {
    item: {
      type: Object as () => Faq,
      required: true
    }
  },
  data(): {
    isOpen: boolean
  } {
    return {
      isOpen: false
    }
  },
  mounted() {
    const images = Array.from(this.$el.getElementsByClassName('sw-FAQItem_Answer')[0].getElementsByTagName('img'))
    if (images.length > 0) {
      images.forEach(image => {
        image.addEventListener('click', () => this.$emit('onImageClick', image.src))
      })
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    }
  }
})
